const setTimeDown = () => import(/* webpackChunkName: "permissions" */ '../../views/setTimeDown'); // 定时导出
export default [
    {
        path: '/setTimeDown',
        name: 'setTimeDown',
        meta: { title: '定时导出',selfFlg: 'export', },

        component: setTimeDown
    }
];
